import loadScript from "@outdoormap/frontend-utils/js/load-script"
import { triggerEvent } from "@outdoormap/frontend-utils/js/event"
import { v4 as uuidv4 } from "uuid"

const MAP_SCRIPT_URL = `https://map-embed.naturkartan.se/embed.js`
const MATOMO_DOMAIN = process.env.GATSBY_MATOMO_DOMAIN
const MATOMO_SITE_ID = process.env.GATSBY_MATOMO_SITE_ID

const initMaps = () => {
  const nodesForMapOnScriptLoad = new Set()
  const initedVarName = `naturkartanMapInited$${uuidv4()}`
  let scriptInited = false

  const injectMap = (node) => {
    if (window.NATURKARTAN_MAP) window.NATURKARTAN_MAP.inject(node)
    else {
      nodesForMapOnScriptLoad.add(node)

      if (!scriptInited) {
        scriptInited = true
        loadScript(MAP_SCRIPT_URL).then(() => {
          nodesForMapOnScriptLoad.forEach((n) => injectMap(n))
          nodesForMapOnScriptLoad.clear()
        })
      }
    }
  }

  new MutationObserver(() => {
    document
      .querySelectorAll(
        `div[data-naturkartan-query]:not([data-naturkartan-inited])`
      )
      .forEach((node) => {
        if (node[initedVarName]) return
        node[initedVarName] = true

        if (node.dataset.naturkartanDisableAutoload == `true`) {
          new IntersectionObserver((entries, observer) => {
            const entry = entries[0]
            if (
              entry.isIntersecting &&
              (!entry.target.dataset.naturkartanInited ||
                entry.target.dataset.naturkartanInited == `false`)
            ) {
              observer.unobserve(entry.target)
              injectMap(entry.target)
            }
          }).observe(node)
        } else injectMap(node)
      })
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
  })
}

export function onClientEntry() {
  initMaps()
}

export function onRouteUpdate({ location, prevLocation }) {
  if (MATOMO_DOMAIN && MATOMO_SITE_ID) {
    window._paq = window._paq || []
    window._paq.push([`setCustomUrl`, window.location.pathname])
    window._paq.push([`setDocumentTitle`, document.title])
    window._paq.push([`trackPageView`])
  }

  // checks if route has changed and triggers `gatsbyRouteChange` event for `window`
  if (location && prevLocation) triggerEvent(window, `gatsbyRouteChange`)
}
